export enum SurveyCodeEnum {
  ADEG_ASSIC = "ADEG_ASSIC",
  ADEG_VER = "ADEGUATAVERIFICA",
}
